import { z } from "zod";

export const notificationSettingsFormSchema = z.object({
    chatNotifications: z.boolean(),
    workOrderNotifications: z.boolean(),
})

export type NotificationSettingsFormType = z.infer<typeof notificationSettingsFormSchema>
